import { useQuery } from '@apollo/client';
import { useIntl } from 'react-intl';

import {
  type GetVitaLocationSuggestionsQuery,
  type GetVitaLocationSuggestionsQueryVariables,
  GetVitaLocationSuggestionsDocument,
} from '@xing-com/crate-lebenslauf-graphql';

type LocationSuggestions = {
  data?: GetVitaLocationSuggestionsQuery;
  refetch: (value: string) => void;
};

export const useLocationSuggestions = (value: string): LocationSuggestions => {
  const { locale } = useIntl();
  const getQueryVariables = (
    text: string
  ): GetVitaLocationSuggestionsQueryVariables => ({
    text,
    consumer: 'loggedout.web.lebenslauf.location',
    language: locale,
  });
  const { data, refetch: refetchSuggestions } =
    useQuery<GetVitaLocationSuggestionsQuery>(
      GetVitaLocationSuggestionsDocument,
      {
        variables: getQueryVariables(value || ''),
        skip: !value,
      }
    );
  const refetch = (value: string): void => {
    refetchSuggestions(getQueryVariables(value));
  };

  return { data, refetch };
};
